var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88014 0.87868C2.44275 0.31607 3.20582 0 4.00146 0H12.0015C12.2667 0 12.521 0.105357 12.7086 0.292893L18.7086 6.29289C18.8961 6.48043 19.0015 6.73478 19.0015 7V19C19.0015 19.7957 18.6854 20.5587 18.1228 21.1213C17.5602 21.6839 16.7971 22 16.0015 22H4.00146C3.20581 22 2.44275 21.6839 1.88014 21.1213C1.31754 20.5587 1.00146 19.7957 1.00146 19V3C1.00146 2.20435 1.31754 1.44129 1.88014 0.87868ZM4.00146 2C3.73625 2 3.48189 2.10536 3.29436 2.29289C3.10682 2.48043 3.00146 2.73478 3.00146 3V19C3.00146 19.2652 3.10682 19.5196 3.29436 19.7071C3.48189 19.8946 3.73625 20 4.00146 20H16.0015C16.2667 20 16.521 19.8946 16.7086 19.7071C16.8961 19.5196 17.0015 19.2652 17.0015 19V7.41421L11.5873 2H4.00146Z",
    fill: "#BB85FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0015 0C12.5537 0 13.0015 0.447715 13.0015 1V6H18.0015C18.5537 6 19.0015 6.44772 19.0015 7C19.0015 7.55228 18.5537 8 18.0015 8H12.0015C11.4492 8 11.0015 7.55228 11.0015 7V1C11.0015 0.447715 11.4492 0 12.0015 0Z",
    fill: "#BB85FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00146 12C5.00146 11.4477 5.44918 11 6.00146 11H14.0015C14.5538 11 15.0015 11.4477 15.0015 12C15.0015 12.5523 14.5538 13 14.0015 13H6.00146C5.44918 13 5.00146 12.5523 5.00146 12Z",
    fill: "#BB85FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00146 16C5.00146 15.4477 5.44918 15 6.00146 15H14.0015C14.5538 15 15.0015 15.4477 15.0015 16C15.0015 16.5523 14.5538 17 14.0015 17H6.00146C5.44918 17 5.00146 16.5523 5.00146 16Z",
    fill: "#BB85FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00146 8C5.00146 7.44772 5.44918 7 6.00146 7H8.00146C8.55375 7 9.00146 7.44772 9.00146 8C9.00146 8.55228 8.55375 9 8.00146 9H6.00146C5.44918 9 5.00146 8.55228 5.00146 8Z",
    fill: "#BB85FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingIcon);
export default __webpack_public_path__ + "static/media/reporting-icon.07bcb669e9261d0451efcaa8fff29480.svg";
export { ForwardRef as ReactComponent };